<template lang="pug">
w-btn-icon.w-btn-next( v-bind=`{ size, noHover }` v-on='$listeners' )
  i-next
</template>

<script lang="js">
import WBtnIcon, { mixin } from './w-btn-icon'
import INext from 'icons/SkipNext'

export default {
  name: 'NextButtonWidget',
  mixins: [ mixin ],
  components: { WBtnIcon, INext },
  props: {
    paused: {
      type: Boolean,
      default: false,
    },
    noHover: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {
    togglePause() {
      this.$emit( this.action )
    },
  },
  computed: {}
}
</script>

<style lang="scss">
.w-btn-next {
  
}
</style>
